import { SubjectCard } from './SubjectCard';
export default SubjectCard;
